<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <h1 class="title">Shop stocktaking</h1>
      <app-cells v-if="is_hotel_reception">
        <app-button @click.native="onCreateStocktaking" ref="createStocktaking">Create stocktaking</app-button>
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #h__receptionist><div class="table-default__left">Receptionist</div></template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'hotel-management-shop-stocktaking-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              Stocktaking - {{row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">{{ dateTimeFormat(row.created_at) }}</template>
        <template #receptionist="{ row }"><div class="table-default__left">{{ row.created_by.full_name }}</div></template>
        <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.completed ? '#77b017' : '#8a8a8a' }">
            {{ row.completed ? 'Completed' : 'Draft' }}
          </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getHotelManagementShopStocktakingList, postHotelManagementShopStocktaking } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'HotelManagementShopStocktaking',
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: [
          'id',
          'date',
          'receptionist',
          'status'
        ],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'receptionist': 'Receptionist',
            'property.name': 'Property',
            'status': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
    if (this.is_general_hotel_supervisor) this.table.columns = ['id', 'date', 'receptionist', 'property.name', 'status']
  },
  computed: {
    is_hotel_reception() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
    },
    is_general_hotel_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  methods: {
    fetchItems() {
      getHotelManagementShopStocktakingList({ page: this.pagination.page, page_size: 20 })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.page_loaded = true
          this.table_preloader = false
        })
    },
    onCreateStocktaking() {
      this.$refs.createStocktaking.preload = true
      postHotelManagementShopStocktaking()
        .then(response => {
          this.$router.push({ name: 'hotel-management-shop-stocktaking-detail', params: { id: response.data.id } })
        })
        .catch(() => { this.$refs.createStocktaking.preload = false })
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
